<template>
  <div>
    <v-dialog
      v-model="computedSnowmakingPipeleaksVisibility"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn icon @click="methodToggleListView('snowmaking', 'pipeleaks')">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title class="hidden-sm-and-down"
            >Pipeleaks</v-toolbar-title
          >
          <v-spacer class="hidden-sm-and-down"></v-spacer>

          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-text-field
            style="margin-top: -10px;"
            append-icon="search"
            single-line
            hide-details
            v-model="search"
            placeholder="Filter data"
          ></v-text-field>
          <v-spacer class="hidden-sm-and-down"></v-spacer>

          <v-btn
            v-if="
              computedAuthProfile === 'admin' ||
                computedAuthProfile === 'maintenance'
            "
            icon
            @click.stop="methodDownloadCSV()"
          >
            <v-icon>get_app</v-icon>
          </v-btn>
          <v-btn icon @click.stop="addPipeleak = true">
            <v-icon>add</v-icon>
          </v-btn>
        </v-toolbar>
        <div
          style="
          background-color: black;
          padding-left: 30px;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        "
        >
          <v-data-table
            :headers="headers"
            :items="computedSnowmakingPipeleakGeoJsonFeatures"
            :rows-per-page-items="rows_per_page"
            :rows-per-page-text="rows_per_page_text"
            :search="search"
            class="elevation-1"
            :loading="computedSnowmakingPipeleaksLoading"
          >
            <template slot="items" slot-scope="props">
              <tr
                @click="
                  methodToggleSingleLayer(
                    'snowmaking',
                    'pipeleaks',
                    true,
                    props.item.properties.id
                  )
                "
              >
                <td>{{ props.item.properties.text }}</td>
                <td>{{ props.item.properties.mountain }}</td>
                <td>{{ props.item.properties.run_pipeli }}</td>
                <td>{{ props.item.properties.loc_detail }}</td>
                <td>{{ props.item.properties.leak_type }}</td>
                <td>{{ props.item.properties.pipe_diam }}</td>
                <td>{{ props.item.properties.pipe_mater }}</td>
                <td>{{ props.item.properties.rupt_type }}</td>
                <td>{{ props.item.properties.estflowgpm }}</td>
                <td>{{ props.item.properties.yr_p_instal }}</td>
                <td>{{ props.item.properties.disc_date }}</td>
                <td>{{ props.item.properties.conf_date }}</td>
                <td>{{ props.item.properties.conf_by }}</td>
                <td>{{ props.item.properties.rep_date }}</td>
                <td>{{ props.item.properties.rep_by }}</td>
                <td>{{ props.item.properties.rep_comple }}</td>
                <td>{{ props.item.properties.comments }}</td>
                <td>{{ props.item.properties.dics_by }}</td>
              </tr>
            </template>

            <!-- Alert when no results found -->
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert
            >
          </v-data-table>
        </div>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <!-- ADD LEAK DIALOG -->
    <v-dialog
      v-model="addPipeleak"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn
            icon
            @click="
              addPipeleak = false;
              clearWatchLocation();
              lat = null;
              lng = null;
              accuracy = null;
              altitude = null;
            "
          >
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Add Pipeleak</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="!tracking"
            :disabled="tracking"
            color="success"
            @click="geoWatchPosition()"
            >Start GPS</v-btn
          >
          <v-btn
            v-if="tracking"
            :disabled="!tracking"
            color="error"
            @click="clearWatchLocation()"
            >Stop GPS</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            v-if="addPipeleak"
            :items="addItemBlank"
            :hide-headers="addItemHideHeaders"
            :hide-actions="addItemHideActions"
          >
            <template slot="items">
              <tr>
                <td>Latitude</td>
                <td>
                  <span v-if="!lat && tracking">Getting latitude...</span>
                  {{ lat }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>
                  <span v-if="!lng && tracking">Getting longitude...</span>
                  {{ lng }}
                </td>
              </tr>
              <tr>
                <td>Accuracy</td>
                <td>
                  <span v-if="!accuracy && tracking">Getting accuracy...</span>
                  {{ accuracy }}
                  <span v-if="accuracy">m</span>
                </td>
              </tr>
              <tr>
                <td>Text</td>
                <td>
                  <v-text-field ref="ref_text" v-model="form.text" />
                </td>
              </tr>
              <tr>
                <td>Mountain</td>
                <td>
                  <v-select
                    ref="ref_mountain"
                    v-model="form.mountain"
                    :items="opt_mountain"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Run pipeline</td>
                <td>
                  <v-text-field
                    ref="ref_run_pipeli"
                    v-model="form.run_pipeli"
                  />
                </td>
              </tr>
              <tr>
                <td>Location details</td>
                <td>
                  <v-text-field
                    ref="ref_loc_detail"
                    v-model="form.loc_detail"
                  />
                </td>
              </tr>
              <tr>
                <td>Leak type</td>
                <td>
                  <v-select
                    ref="ref_leak_type"
                    v-model="form.leak_type"
                    :items="opt_leak_type"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Pipe diameter (inch)</td>
                <td>
                  <v-select
                    ref="ref_pipe_diam"
                    v-model="form.pipe_diam"
                    :items="opt_pipe_diam"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Pipe material</td>
                <td>
                  <v-select
                    ref="ref_pipe_mater"
                    v-model="form.pipe_mater"
                    :items="opt_pipe_mater"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Rupture type</td>
                <td>
                  <v-select
                    ref="ref_rupt_type"
                    v-model="form.rupt_type"
                    :items="opt_rupt_type"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Estimated flow (GPM)</td>
                <td>
                  <v-text-field
                    ref="ref_estflowgpm"
                    v-model="form.estflowgpm"
                  />
                </td>
              </tr>
              <tr>
                <td>Discovery Date</td>
                <td>
                  <v-menu
                    ref="menu_disc_date"
                    close-on-content-click
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        ref="ref_disc_date"
                        v-model="form.disc_date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.disc_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_disc_date = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_disc_date.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </td>
              </tr>
              <tr>
                <td>Discovered by</td>
                <td>
                  <v-text-field ref="ref_dics_by" v-model="form.dics_by" />
                </td>
              </tr>
              <tr>
                <td>Confirmation Date</td>
                <td>
                  <v-menu
                    ref="menu_conf_date"
                    close-on-content-click
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        ref="ref_conf_date"
                        v-model="form.conf_date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.conf_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_conf_date = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_conf_date.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </td>
              </tr>
              <tr>
                <td>Confirmed by</td>
                <td>
                  <v-select
                    ref="ref_conf_by"
                    v-model="form.conf_by"
                    :items="opt_conf_by"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Repair Date</td>
                <td>
                  <v-menu
                    ref="menu_rep_date"
                    close-on-content-click
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        ref="ref_rep_date"
                        v-model="form.rep_date"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="form.rep_date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_rep_date = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_rep_date.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </td>
              </tr>
              <tr>
                <td>Repaired by</td>
                <td>
                  <v-text-field ref="ref_rep_by" v-model="form.rep_by" />
                </td>
              </tr>
              <tr>
                <td>Repair complete</td>
                <td>
                  <v-select
                    ref="ref_rep_comple"
                    v-model="form.rep_comple"
                    :items="opt_yes_no"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Comments</td>
                <td>
                  <v-textarea
                    ref="ref_comments"
                    v-model="form.comments"
                  ></v-textarea>
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td colspan="100%">
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                  <v-btn
                    @click.stop="
                      methodAddSnowmakingPipeleaksGeoJson();
                      addPipleak = false;
                      clearWatchLocation();
                      lat = null;
                      lng = null;
                      accuracy = null;
                      altitude = null;
                    "
                    color="success"
                    :disabled="!lat || !lng"
                    >Save</v-btn
                  >
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { parse } from "json2csv";
export default {
  data() {
    return {
      menu_disc_date: false,
      menu_conf_date: false,
      menu_rep_date: false,
      form: {
        text: null,
        mountain: null,
        run_pipeli: null,
        loc_detail: null,
        leak_type: null,
        pipe_diam: null,
        pipe_mater: null,
        rupt_type: null,
        estflowgpm: null,
        disc_date: null,
        conf_date: null,
        conf_by: null,
        rep_date: null,
        rep_by: null,
        rep_comple: null,
        comments: null,
        dics_by: null
      },
      addPipeleak: false,
      lat: null,
      lng: null,
      accuracy: null,
      altitude: null,
      tracking: false,
      watchId: null,
      opt_mountain: [
        {
          text: "Whistler"
        },
        { text: "Blackcomb" }
      ],
      opt_leak_type: [
        {
          text: "Water"
        },
        { text: "Air" }
      ],
      opt_pipe_diam: [
        { text: 2 },
        { text: 4 },
        { text: 6 },
        { text: 8 },
        { text: 10 },
        { text: 12 },
        { text: 16 }
      ],
      opt_pipe_mater: [
        { text: "Steel" },
        { text: "HDPE" },
        { text: "Unknown" }
      ],
      opt_rupt_type: [
        { text: "Tear" },
        { text: "Pin Hole" },
        { text: "Failed weld" },
        { text: "Failed fuse" }
      ],
      opt_conf_by: [
        { text: "Gyser" },
        { text: "Draining Pipe" },
        { text: "Blowhole" }
      ],
      opt_yes_no: [{ text: "Yes" }, { text: "No" }],
      addItemBlank: [""],
      addItemHideHeaders: true,
      addItemHideActions: true,
      rows_per_page: [
        10,
        25,
        50,
        {
          text: "All",
          value: -1
        }
      ],
      rows_per_page_text: "Per page:",
      loading: true,
      search: "",
      headers: [
        {
          text: "Text",
          value: "properties.text"
        },
        {
          text: "Mountain",
          value: "properties.mountain"
        },
        {
          text: "Run pipeline",
          value: "properties.run_pipeli"
        },
        {
          text: "Location details",
          value: "properties.loc_details"
        },
        {
          text: "Leak type",
          value: "properties.leak_type"
        },
        {
          text: "Pipe diameter",
          value: "properties.pipe_diam"
        },
        {
          text: "Pipe material",
          value: "properties.pipe_mater"
        },
        {
          text: "Rupture type",
          value: "properties.rupt_type"
        },
        {
          text: "Est flow (GPM)",
          value: "properties.estflowgpm"
        },
        {
          text: "Year installed",
          value: "properties.yr_p_instal"
        },
        {
          text: "Discovery date",
          value: "properties.disc_date"
        },
        {
          text: "Confirmation date",
          value: "properties.conf_date"
        },
        {
          text: "Confirmed by",
          value: "properties.conf_by"
        },
        {
          text: "Repair date",
          value: "properties.rep_date"
        },
        {
          text: "Repaired by",
          value: "properties.rep_by"
        },
        {
          text: "Repair completed?",
          value: "properties.rep_comple"
        },
        {
          text: "Comments",
          value: "properties.comments"
        },
        {
          text: "Discovered by",
          value: "properties.dics_by"
        }
      ]
    };
  },
  computed: {
    computedSnowmakingPipeleakGeoJsonFeatures() {
      return this.$store.state.mapLayers.snowmaking.layers.pipeleaks.geojson
        .features;
    },
    computedSnowmakingPipeleaksVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.pipeleaks.visibility
        .listView;
    },
    computedSnowmakingPipeleaksLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.pipeleaks.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodAddSnowmakingPipeleaksGeoJson() {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [this.lng, this.lat]
            },
            properties: {
              text: this.form.text,
              mountain: this.form.mountain,
              run_pipeli: this.form.run_pipeli,
              loc_detail: this.form.loc_detail,
              leak_type: this.form.leak_type,
              pipe_diam: this.form.pipe_diam,
              pipe_mater: this.form.pipe_mater,
              rupt_type: this.form.rupt_type,
              estflowgpm: parseInt(this.form.estflowgpm || null),
              disc_date: this.form.disc_date,
              conf_date: this.form.conf_date,
              conf_by: this.form.conf_by,
              rep_date: this.form.rep_date,
              rep_by: this.form.rep_by,
              rep_comple: this.form.rep_comple,
              comments: this.form.comments,
              dics_by: this.form.dics_by
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipeleaks",
          dept: "snowmaking",
          layer: "pipeleaks",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(
          setTimeout(() => {
            this.methodGetSnowmakingPipeleaksGeoJson();
          }, 250)
        );
    },
    geoSuccess(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
      this.altitude = position.coords.altitude;
    },
    geoError() {
      console.log("geo error");
    },
    geoWatchPosition() {
      let geoOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };
      this.tracking = true;
      this.watchId = navigator.geolocation.watchPosition(
        this.geoSuccess,
        this.geoError,
        geoOptions
      );
    },
    clearWatchLocation() {
      navigator.geolocation.clearWatch(this.watchId);
      this.tracking = false;
    },

    methodDownloadCSV() {
      const fields = [
        {
          label: "Text",
          value: "properties.text"
        },
        {
          label: "Mountain",
          value: "properties.mountain"
        },
        {
          label: "Run pipeline",
          value: "properties.run_pipeli"
        },
        {
          label: "Location details",
          value: "properties.loc_details"
        },
        {
          label: "Leak type",
          value: "properties.leak_type"
        },
        {
          label: "Year pipe installed",
          value: "properties.yr_p_instal"
        },
        {
          label: "Pipe diameter",
          value: "properties.pipe_diam"
        },
        {
          label: "Pipe material",
          value: "properties.pipe_mater"
        },
        {
          label: "Rupture type",
          value: "properties.rupt_type"
        },
        {
          label: "Est flow (GPM)",
          value: "properties.estflowgpm"
        },
        {
          label: "Discovery date",
          value: "properties.disc_date"
        },
        {
          label: "Confirmation date",
          value: "properties.conf_date"
        },
        {
          label: "Confirmed by",
          value: "properties.conf_by"
        },
        {
          label: "Repair date",
          value: "properties.rep_date"
        },
        {
          label: "Repaired by",
          value: "properties.rep_by"
        },
        {
          label: "Repair completed?",
          value: "properties.rep_comple"
        },
        {
          label: "Discovered by",
          value: "properties.dics_by"
        }
      ];
      const opts = { fields };

      try {
        const csv = parse(
          this.$store.state.mapLayers.snowmaking.layers.pipeleaks.geojson
            .features,
          opts
        );
        const blob = new Blob([csv], { type: "octet/stream" });
        const a = document.createElement("a");
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "snowmaking_pipeleaks.csv";
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0);
      } catch (err) {
        console.error(err);
      }
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetSnowmakingPipeleaksGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipeleaks",
        dept: "snowmaking",
        layer: "pipeleaks",
        token: this.computedAuthToken
      });
    },
    methodAddSnowmakingPipeleakGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [this.lng, this.lat]
            },
            properties: {
              hydrnt_num: data.hydrnt_num,
              "30a": data["30a"],
              "60a": data["60a"],
              water: data.water,
              air: data.air,
              circuit: data.circuit,
              elec_maint_name: data.elec_maint_name,
              notes: data.notes,
              edit_by: data.edit_by,
              modified: this.pgDateFunc(Date.now())
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/pipeleaks",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(() => {
          setTimeout(() => {
            this.methodGetSnowmakingPipeleaksGeoJson();
          }, 250);
        });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.pipeleaks.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSnowmakingPipeleaksGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.pipeleaks.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
